module.exports = __webpack_public_path__ + "static/media/1 12 sjal.10de5b8e.mp3";